import React, { useState } from "react";

import useBrowser from "../../hooks/useBrowser";
import useSynchronization from "../../hooks/useSynchronization";

import { Box } from "@mui/material";

import MultiSelectList from "../elements/MultiSelectList";

import Card from "../layout/Card";
import EditorToolbar from "../editors/EditorToolbar";

const syncItems = [
  { id: "Retailer", name: "Retailers" },
  { id: "Banner", name: "Banners" },
  { id: "Location", name: "Locations" },
  { id: "Syndication", name: "Syndication" },
  { id: "Client", name: "Clients" },
  { id: "Project", name: "Projects" },
  { id: "ProjectLocation", name: "Project Locations" },
  { id: "SKU", name: "SKUs" },
  { id: "SKUPricing", name: "Pricing" },
  { id: "SKUListing", name: "Listings" },
  { id: "Survey", name: "Surveys" },
  { id: "SurveyPage", name: "Survey Pages" },
  { id: "SurveySection", name: "Survey Sections" },
  { id: "SurveyQuestion", name: "Survey Questions" },
  { id: "Call", name: "Calls" },
  { id: "CallResult", name: "Call Results" },
  { id: "SurveyAnswer", name: "Survey Answers" },
  { id: "Variability", name: "Variability" },
  { id: "Document", name: "Documents" },
  { id: "User", name: "Users" },
];

const SyncReset = ({ height }) => {
  const { windowHeight } = useBrowser();
  const { resetSyncItems } = useSynchronization();

  const [selectedItems, setSelecteditems] = useState([]);

  const handleSave = async () => {
    const results = await resetSyncItems(selectedItems);
  };

  return (
    <Card
      title="Reset"
      width="300px"
      sx={{
        height: `${windowHeight - 150}px`,
      }}
    >
      <EditorToolbar onSave={handleSave} />
      <Box
        sx={{
          height: `${windowHeight - 220}px`,
          overflow: "auto",
        }}
      >
        <MultiSelectList
          options={syncItems}
          value={selectedItems}
          onChange={(newValue) => setSelecteditems(newValue)}
        />
      </Box>
    </Card>
  );
};

export default SyncReset;
